module.exports = __webpack_public_path__ + "static/media/phone-alt.ecd35f08.svg";